import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

export default function CompanySkeleton({ rows = 8 }) {
  return (
    <div className="reveal" aria-hidden="true">
      <table className="min-w-full divide-y divide-gray-300 dark:divide-slate-500">
        <thead>
          <tr>
            <th className="py-3.5 pr-3 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Logo
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Company Name
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Owner Name
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Owner Phone
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Stores
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Users
            </th>
            <th className="py-3.5 px-4 text-right">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-slate-500">
          {[...Array(rows)].map((_, idx) => (
            <tr key={idx}>
              <td className="whitespace-nowrap py-4 pr-3">
                <SkeletonBlock className="h-9 w-9 !rounded-full" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-40 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-28 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-24 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-12 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-12 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4 text-right">
                <SkeletonBlock className="ml-auto h-8 w-8 !rounded-full" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-4 flex w-full items-center justify-between gap-3">
        <SkeletonBlock className="h-4 w-56 max-w-full rounded" />
        <SkeletonBlock className="h-8 w-64 max-w-full rounded-md" />
      </div>
    </div>
  );
}
